export default {
  body: {
    fontFamily: 'Open Sans',
    lineHeight: 'base',
    color: '#000',
    WebkitTextSizeAdjust: '100%',
    WebkitTapHighlightColor: 'transparent'
  },
  '*': {
    boxSizing: 'border-box'
  },
  '*:focus': {
    outline: 'none',
    boxShadow: 'none'
  },
  '.react-select__menu': {
    cursor: 'pointer !important',
    'z-index': '2 !important'
  },
  '.react-select__control': {
    cursor: 'pointer !important'
  },
  '.react-select__follow-up': {
    minWidth: '200px',

    '.react-select__control': {
      maxHeight: '35px',
      overflow: 'auto !important',
      position: 'relative !important',

      '.react-select__indicators': {
        height: '35px !important',
        position: 'sticky !important',
        top: 0
      }
    }
  },
  '.react-select__control--is-focused': {
    borderColor: '#ECC94B!important',
    boxShadow: '0 0 0 1px #ECC94B!important'
  },
  '.chakra-numberinput__field:focus': {
    borderColor: '#ECC94B!important',
    boxShadow: '0 0 0 1px #ECC94B!important'
  },
  '.scl-table-grid': {
    position: 'relative',
    backgroundColor: '#fff',
    textAlign: 'left',
    borderCollapse: 'separate',
    borderSpacing: 0,
    minW: '100%',
    overflow: 'auto !important',

    'td,th': {
      border: '1px solid',
      borderColor: 'gray.200',
      padding: '6px 12px'
    },

    thead: {
      background: 'gray.100',

      td: {
        fontSize: '14px',
        fontWeight: '600',
        color: 'gray.500'
      },
      th: {
        minW: 'fit-content',
        fontSize: '14px',
        fontWeight: '600',
        color: 'gray.700',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      tr: {
        span: {
          lineHeight: '24px'
        },

        '&.actions': {
          textAlign: 'center'
        }
      }
    },

    tbody: {
      overflow: 'scroll',
      '.select-line': {
        background: 'green.100'
      },
      '.show-icon': {
        '.icon-button-modal': {
          opacity: '.1'
        },
        '&:hover': {
          '.icon-button-modal': {
            opacity: '1'
          }
        }
      },
      tr: {
        background: 'gray.50',
        transition: 'all ease .3s',
        '.custom': {
          background: 'white'
        },
        '.custom-display': {
          display: 'none'
        },
        '.tr-gray': {
          background: 'gray.300'
        },
        '&:hover': {
          bgColor: 'yellow.50',
          cursor: 'pointer',
          td: {
            borderLeftColor: 'yellow.50',
            borderRightColor: 'yellow.50'
          }
        }
      },
      td: {
        fontSize: '14px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  },
  '.scl-table-grid-v2': {
    position: 'relative',
    backgroundColor: '#fff',
    textAlign: 'left',
    borderCollapse: 'separate',
    borderSpacing: 0,
    minW: '100%',
    overflow: 'auto !important',

    'td,th': {
      border: '1px solid',
      borderColor: 'gray.200',
      padding: '6px 12px'
    },

    thead: {
      td: {
        fontSize: '14px',
        fontWeight: '600',
        color: 'gray.500'
      },
      th: {
        minW: 'fit-content',
        fontSize: '14px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      tr: {
        span: {
          lineHeight: '24px'
        },

        '&.actions': {
          textAlign: 'center'
        }
      }
    },

    tbody: {
      overflow: 'scroll',
      '.select-line': {
        background: 'green.100'
      },
      '.show-icon': {
        '.icon-button-modal': {
          opacity: '.1'
        },
        '&:hover': {
          '.icon-button-modal': {
            opacity: '1'
          }
        }
      },
      tr: {
        background: 'gray.50',
        transition: 'all ease .3s',
        '.custom': {
          background: 'white'
        },
        '.custom-display': {
          display: 'none'
        },
        '.tr-gray': {
          background: 'gray.300'
        },
        '&:hover': {
          bgColor: 'yellow.50',
          cursor: 'pointer',
          td: {
            borderLeftColor: 'yellow.50',
            borderRightColor: 'yellow.50'
          }
        }
      },
      td: {
        fontSize: '14px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    }
  },
  '.sticky-header': { position: 'sticker', top: 0, 'z-index': 1 },
  '.pagination': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    listStyle: 'none',
    margin: '0',
    height: '32px',
    padding: '0 8px',
    background: '#fff',

    li: {
      margin: '0 4px',

      a: {
        padding: '4px 8px',
        fontSize: '12px',
        borderRadius: '4px',
        backgroundColor: '#fff',
        color: '#000',
        transition: 'all 0.2s ease',

        '&:hover': {
          background: 'green.100',
          color: '#000'
        }
      },

      '&.active': {
        a: {
          background: 'green.600',
          color: 'white'
        }
      },

      '&.previous, &.next': {
        a: {
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '14px',
          backgroundColor: '#fff',
          color: 'green.600',

          '&:hover': {
            background: 'gray.50',
            color: 'green.600'
          }
        },

        '&.disabled': {
          a: {
            background: '#fff',
            color: 'gray.300',
            cursor: 'not-allowed'
          }
        }
      },

      '&.previous': {
        marginRight: 'auto'
      },
      '&.next': {
        marginLeft: 'auto!important'
      }
    }
  },
  '.filter-select': {
    cursor: 'pointer'
  }
}
